import { Controller } from "@hotwired/stimulus"
import { TOAST_TIMEOUT, TOAST_CLASSES } from "../constants/toast_constants"

// Connects to data-controller="toast"
export default class extends Controller {
  static targets = ["toastItem"]

  connect() {
    this.toastItemTargets.forEach(item => {
      this.autoDismiss(item);
    });
  }

  show(
      message,
      type = "notice",
      replace = false,
      timeout = TOAST_TIMEOUT
  ) {
    if (!message) return;

    const toastClass = TOAST_CLASSES[type] || TOAST_CLASSES.notice;

    const toast = document.createElement("div");
    toast.className = toastClass;
    toast.textContent = message;

    if (replace) {
      this.element.replaceChildren(toast);
    } else {
      this.element.appendChild(toast);
    }

    this.autoDismiss(toast, timeout);
  }

  autoDismiss(element, timeout = TOAST_TIMEOUT) {
    setTimeout(() => {
      element.remove();
    }, timeout);
  }
}
